import React, { createContext, useState, useContext } from "react";

const SpaceConfigurationsConfigContext = createContext();

export default function SpaceConfigurationsConfigProvider(props) {
    const tempContactIDStart = 10000000;
    
    const getInitialState = () => {
        const jsonString = document.getElementById(props.configContainerID).value;
        return JSON.parse(jsonString);
    };

    const updateAspNetInput = (newSpaceConfigurationsConfig) => {
        const element = document.getElementById(props.configContainerID);
        const json = JSON.stringify(newSpaceConfigurationsConfig);
        element.value = json;
    };

    const initialState = getInitialState();

    const [spaceConfigurationsConfig, setSpaceConfigurationsConfig] = useState(initialState);

    const addSpaceConfiguration = () => {
        // Fetch the template JSON for a new Sales Rep
        let json = JSON.parse(document.getElementById(props.templateContainerID).value);
        const spaceConfigurationCount = spaceConfigurationsConfig.SpaceConfigurations.length;

        const newSpaceConfigurationsConfig = JSON.parse(JSON.stringify(spaceConfigurationsConfig));

        // Allocate a temporary id by finding the max value already allocated and then incrementing
        let maxID = Math.max(...spaceConfigurationsConfig.SpaceConfigurations.map(o => o.SpaceConfigurationID), tempContactIDStart);
        json.SpaceConfigurationID = maxID + 1;
        json.IsActive = true;
        
        // Assign the first type because the editor will look like it's assigned because no default value
        // so this makes it explicit
        // Get the first unreferenced type
        const unreferencedTypes = availableTypes(spaceConfigurationsConfig);
        if (unreferencedTypes.length > 0) {
            json.Type = unreferencedTypes[0].Value;
        }

        newSpaceConfigurationsConfig.SpaceConfigurations.splice(spaceConfigurationCount, 0, json);

        setSpaceConfigurationsConfig(newSpaceConfigurationsConfig);
        updateAspNetInput(newSpaceConfigurationsConfig);
    };

    const updateSpaceConfiguration = (spaceConfigurationID, fieldName, value) => {
        let existingSession = getSpaceConfiguration(spaceConfigurationID);
        let index = spaceConfigurationsConfig.SpaceConfigurations.indexOf(existingSession);

        var newSpaceConfigurationsConfig = JSON.parse(JSON.stringify(spaceConfigurationsConfig));
        newSpaceConfigurationsConfig.SpaceConfigurations[index][fieldName] = value;

        setSpaceConfigurationsConfig(newSpaceConfigurationsConfig);
        updateAspNetInput(newSpaceConfigurationsConfig);
    };

    const removePendingSpaceConfiguration = (spaceConfigurationID) => {
        let existingSession = getSpaceConfiguration(spaceConfigurationID);
        let index = spaceConfigurationsConfig.SpaceConfigurations.indexOf(existingSession);

        var newSpaceConfigurationsConfig = JSON.parse(JSON.stringify(spaceConfigurationsConfig));

        // Remove one element
        newSpaceConfigurationsConfig.SpaceConfigurations.splice(index, 1);

        setSpaceConfigurationsConfig(newSpaceConfigurationsConfig);
        updateAspNetInput(newSpaceConfigurationsConfig);
    };

    const deleteSpaceConfiguration = (spaceConfigurationID) => {
        // Is this a contact not yet written to the database?
        if (spaceConfigurationID >= tempContactIDStart) {
            removePendingSpaceConfiguration(spaceConfigurationID);
        }
        else {
            updateSpaceConfiguration(spaceConfigurationID, "IsActive", false);
        }
        
    };

    const restoreSpaceConfiguration = (spaceConfigurationID) => {
        updateSpaceConfiguration(spaceConfigurationID, "IsActive", true);
    };

    // Get the list of configuration types which are still available to assign
    const availableTypes = (exceptByID) => {
        const referencedTypes = new Set(spaceConfigurationsConfig.SpaceConfigurations
            .filter(f => f.SpaceConfigurationID != exceptByID)
            .map(spaceConfiguration => spaceConfiguration.Type));
        return spaceConfigurationsConfig.Types.filter(type => !referencedTypes.has(type.Value));
    }

    const getSpaceConfiguration = (id) => {
        let found = spaceConfigurationsConfig.SpaceConfigurations.find(f => f.SpaceConfigurationID === id);

        return found;
    };

    return (
        <SpaceConfigurationsConfigContext.Provider value={{
            spaceConfigurationsConfig,
            getSpaceConfiguration, availableTypes,
            addSpaceConfiguration, updateSpaceConfiguration, deleteSpaceConfiguration, restoreSpaceConfiguration
        }}>
            {props.children}
        </SpaceConfigurationsConfigContext.Provider>
    );
}

export const useSpaceConfigurationsConfig = () => useContext(SpaceConfigurationsConfigContext);